import { log } from '@/log'
import { ApiNoveltyCampaign } from '@/models/api/campaign/noveltyCampaign'
import { CartItemList } from '@/models/cart/cart-item'
import { extractDisplayedPurchasableItems } from '@spa/store/modules/cart/function'

export interface BundleApplied {
  readonly discount: number
}

export interface SourceOfBasePrice {
  wholeCartItemList: CartItemList // 特定のスコープのカート内商品全て・もしくは特定のスコープのカート内の単発注文商品全て
  novelty: Pick<ApiNoveltyCampaign, 'canUseForBasePrice'>
  bundleApply: BundleApplied
}

/**
 * @see https://github.com/my-color/front/issues/4453#issuecomment-698063746
 * @see https://github.com/my-color/front/issues/4453#issuecomment-700682973
 */
export const basePriceToSelectNovelty = (
  { wholeCartItemList, novelty, bundleApply }: SourceOfBasePrice
): number => {

  const totalPrice = new CartItemList(extractDisplayedPurchasableItems(wholeCartItemList.list))
    .filter(i => novelty.canUseForBasePrice(i))
    .totalPrice
  const discountPrice = bundleApply.discount

  if (totalPrice < discountPrice) {
    log.warn(`total price in cart(${totalPrice}) < discount price by bundle(${discountPrice}). so use 0 forcibly`)

    return 0
  }

  return totalPrice - discountPrice
}
